// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/poxmrng1";globalThis["SENTRY_RELEASE"] = {"id":"d6f31221e66740fb45b5b1d1157e9c500edd87f6"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "14.2.25";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/@tokenModaltoken/:contractAddress/:id\",\"regex\":\"^/@tokenModaltoken/([^/]+)/([^/]+)$\",\"paramNames\":[\"contractAddress\",\"id\"]},{\"path\":\"/articles/:slug\",\"regex\":\"^/articles/([^/]+)$\",\"paramNames\":[\"slug\"]},{\"path\":\"/artists/:idOrSlug\",\"regex\":\"^/artists/([^/]+)$\",\"paramNames\":[\"idOrSlug\"]},{\"path\":\"/collection/:idOrSlug\",\"regex\":\"^/collection/([^/]+)$\",\"paramNames\":[\"idOrSlug\"]},{\"path\":\"/collection/:idOrSlug/purchase\",\"regex\":\"^/collection/([^/]+)/purchase$\",\"paramNames\":[\"idOrSlug\"]},{\"path\":\"/discover/:vertical\",\"regex\":\"^/discover/([^/]+)$\",\"paramNames\":[\"vertical\"]},{\"path\":\"/profile/:walletOrUsername\",\"regex\":\"^/profile/([^/]+)$\",\"paramNames\":[\"walletOrUsername\"]},{\"path\":\"/profile/:walletOrUsername/achievements\",\"regex\":\"^/profile/([^/]+)/achievements$\",\"paramNames\":[\"walletOrUsername\"]},{\"path\":\"/profile/:walletOrUsername/sets\",\"regex\":\"^/profile/([^/]+)/sets$\",\"paramNames\":[\"walletOrUsername\"]},{\"path\":\"/profile/:walletOrUsername/sets/:slug\",\"regex\":\"^/profile/([^/]+)/sets/([^/]+)$\",\"paramNames\":[\"walletOrUsername\",\"slug\"]},{\"path\":\"/token/:contractAddress/:id\",\"regex\":\"^/token/([^/]+)/([^/]+)$\",\"paramNames\":[\"contractAddress\",\"id\"]}],\"staticRoutes\":[{\"path\":\"/403\"},{\"path\":\"/\"},{\"path\":\"/articles\"},{\"path\":\"/artists\"},{\"path\":\"/calendar\"},{\"path\":\"/discover\"},{\"path\":\"/exhibitions\"},{\"path\":\"/exhibitions/bokeh-by-mpkoz\"},{\"path\":\"/exhibitions/bokeh-by-mpkoz/creator\"},{\"path\":\"/exhibitions/busy-by-james-merrill\"},{\"path\":\"/exhibitions/gas-wars-by-jack-butcher\"},{\"path\":\"/exhibitions/poetics-of-the-infinite\"},{\"path\":\"/exhibitions/quine-by-larva-labs\"},{\"path\":\"/login\"},{\"path\":\"/profile/settings\"},{\"path\":\"/secondary-marketplace\"},{\"path\":\"/timeline\"}]}";import * as Sentry from '@sentry/nextjs'

const isProd = process.env.NODE_ENV === 'production'
const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN

// Only enable instrumentation if in production env
if (isProd) {
  enableInstrumentation()
}

export function onRouterTransitionStart(url: string, navigationType: 'push' | 'replace' | 'traverse') {
  if (isProd) {
    return Sentry.captureRouterTransitionStart(url, navigationType)
  }
}

function enableInstrumentation() {
  initSentry()
}

function initSentry() {
  Sentry.init({
    dsn: SENTRY_DSN,

    // Add optional integrations for additional features
    integrations: [Sentry.replayIntegration()],

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,

    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // Define how likely Replay events are sampled when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    environment: process.env.NEXT_PUBLIC_CURRENT_ENV
  })
}
